import React from 'react';
import { IntlProvider } from 'react-intl';
import { AuthProvider } from '../context';
import LayoutWrapper from './layout-wrapper';
import { setClientSideTranslations } from '../../i18n';
import TranslationProvider from '../providers/TranslationProvider';
const Layout = (props) => {
    setClientSideTranslations(props);
    return (React.createElement(IntlProvider, { locale: props.layout.locale },
        React.createElement(AuthProvider, { isAuthRequired: props.isAuthRequired, isBypassContext: props.isBypassAuthContext, fallback: props.fallback },
            React.createElement(TranslationProvider, null,
                React.createElement(LayoutWrapper, Object.assign({}, props))))));
};
export default Layout;
//# sourceMappingURL=index.js.map